// Central media map. Only media explicitly provided by Kensmarc Electric
// belongs here. Brand files are built from Marcos's real logo by
// /app/brand-assets/build_logo.py (emblem extracted, never redrawn).
export const MEDIA = {
  logo: "/brand/kensmarc-mark.png",
  logoStacked: "/brand/kensmarc-logo-stacked.png",
  icon: "/brand/kensmarc-icon.png",
  og: "/brand/kensmarc-og.png",
};
